import { z, ZodType, ZodTypeDef } from 'zod/v3';
import { isIsoDate, ISODate } from '../dateUtils';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './zIsoDate.translations.json';

const { addTranslations, t } = i18nNsFactory('iso-date');
addTranslations(translations);

export const zIsoDate = (
  messageFn?: () => string | undefined,
): ZodType<ISODate, ZodTypeDef, ISODate> =>
  z.custom<ISODate>(isIsoDate, () => ({
    message: messageFn?.() || t('iso-date'),
  }));
